import createStyles from "../../pages/onboarding/CreateApplicationStep.module.css";
import styles from "./GuarantorBackingScreen.module.css";

type GuarantorBackingScreenProps = {
  show: boolean;
  fullName: string;
  firstName: string;
  // Null for case 12 (nothing shared yet); landlord name for case 13.
  landlordName: string | null;
  onDashboard: () => void;
  dashboardBusy: boolean;
  _t: (key: string, fallback?: string, ns?: string, args?: any) => string;
};

// G result screen for cases 12-13: confirms whose application the user now
// backs. Case 12 states nothing is shared yet; case 13 names the landlord the
// verified profile now reaches.
const GuarantorBackingScreen = ({
  show,
  fullName,
  firstName,
  landlordName,
  onDashboard,
  dashboardBusy,
  _t,
}: GuarantorBackingScreenProps) => {
  if (!show) return null;

  return (
    <div className={`${createStyles.overlay} modal-fixed-screen`}>
      <main
        className={`${createStyles.card} ${styles.shell} onboarding-modal-surface`}
      >
        <div className={styles.checkWrap} aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="m5 12.5 4.5 4.5L19 7.5" />
          </svg>
        </div>
        <div className={styles.heading}>
          <h1>
            {_t("guarantorBackingTitle", "", undefined, { full: fullName })}
          </h1>
          <p className={createStyles.intro}>
            {landlordName
              ? _t("guarantorBackingReachesLandlord", "", undefined, {
                  landlord: landlordName,
                  first: firstName,
                })
              : _t("guarantorBackingNothingShared", "", undefined, {
                  first: firstName,
                })}
          </p>
        </div>
        <button
          type="button"
          className={styles.dashboardButton}
          onClick={onDashboard}
          disabled={dashboardBusy}
        >
          {dashboardBusy ? "..." : _t("goToMyDashboard")}
        </button>
        <p className={styles.toldLine}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 9.5a6 6 0 0 1 12 0c0 4 1.5 5.5 1.5 5.5h-15C4.5 15 6 13.5 6 9.5" />
            <path d="M10 19a2.2 2.2 0 0 0 4 0" />
          </svg>
          <span>
            {_t("guarantorBackingTenantTold", "", undefined, {
              first: firstName,
            })}
          </span>
        </p>
      </main>
    </div>
  );
};

export default GuarantorBackingScreen;
